import CLIENT from "../../lib/api/client";
import ENDPOINTS from "../../lib/api/endpoints";

export const ALL_PAGE_SIZE = -1;
export const MIN_RATING = 1;
export const MAX_RATING = 5;
export const REVIEW_MAX_LENGTH = 1000;

export const clampRating = (value) => {
  const number = Number(value);

  if (!Number.isFinite(number)) return 0;

  return Math.min(MAX_RATING, Math.max(MIN_RATING, Math.round(number * 10) / 10));
};

export const fetchMyRatings = async ({
  page = 1,
  pageSize = 20,
  targetType,
  sortBy,
} = {}) => {
  const { data } = await CLIENT.get(ENDPOINTS.RATINGS.mine, {
    params: {
      page,
      page_size: pageSize,
      ...(targetType ? { target_type: targetType } : {}),
      ...(sortBy ? { sort_by: sortBy } : {}),
    },
  });

  return data;
};

export const createRating = async ({ targetType, targetId, rating, review }) => {
  const { data } = await CLIENT.post(ENDPOINTS.RATINGS.root, {
    ratedTargetType: targetType,
    ratedTargetId: Number(targetId),
    rating: clampRating(rating),
    review: review || "",
  });

  return data;
};

export const updateRating = async ({ id, rating, review }) => {
  const { data } = await CLIENT.put(ENDPOINTS.RATINGS.byId(id), {
    rating: clampRating(rating),
    review: review || "",
  });

  return data;
};

export const deleteRating = async (id) => {
  await CLIENT.delete(ENDPOINTS.RATINGS.byId(id));
};
